import React from "react";

function ArrowSvg(props){

    return(
        <>
        <div id={props.id ? props.id : "null"} className={props.class ? props.class : ""}>
            <svg viewBox="0 0 24 24" fill="none"  width="24" height="24" role="presentation" focusable="false">
                <path d="M5 11.75h12m-5.25-6.5 6.25 6.5-6.25 6.5" stroke="currentColor" strokeWidth="1.5" strokeMiterlimit="10"></path>
            </svg>
        </div>
        </>
    )
}

export default ArrowSvg;